export default {
    preLoad: 1.3,
    error: '/static/testimg/lazyload/error.png',
    loading: '/static/testimg/lazyload/loading.gif',
    attempt: 1,
};
